import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Calculator",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-calculator",
    args: {
        calculatorId: "",
        cssClasses: "",
        initialValue: 0,
        locale: "",
        matrix: "",
    },
    argTypes: {
        calculatorId: { control: "text" },
        cssClasses: { control: "text" },
        initialValue: { control: "number" },
        locale: { control: "text" },
        matrix: { control: "any[] | boolean" },
    },
};

const Template = ({ calculatorId, initialValue }) =>
    html`<p class="ux-text-normal">
            The ux-iws-calculator component has been given 10 as initial value
            in this example
        </p>
        <ux-form-group label="Select a software">
            <ux-radio-button
                label="Item with value 20"
                name="feature"
                checked
                data-ux-calculator="${calculatorId}"
                data-ux-calculator-value="20"
            ></ux-radio-button>
            <ux-radio-button
                label="Item with value 30"
                name="feature"
                data-ux-calculator="${calculatorId}"
                data-ux-calculator-value="30"
            ></ux-radio-button>
            <ux-radio-button
                label="Item with value 45.5"
                name="feature"
                data-ux-calculator="${calculatorId}"
                data-ux-calculator-value="45.5"
            ></ux-radio-button>
        </ux-form-group>
        <div class="ux-u-margin-top-15">
            <ux-checkbox
                label="Discount: element with value -5"
                name="discount"
                data-ux-calculator="${calculatorId}"
                data-ux-calculator-value="-5"
            ></ux-checkbox>
        </div>
        <div class="ux-u-margin-top-15">
            <div class="ux-label">
                Your total price is:
            </div>
            <ux-iws-calculator
                initial-value="${initialValue}"
                calculator-id="${calculatorId}"
                css-classes="ux-text-headline ux-text-headline--big"
            >
                <span slot="prefix">€</span>
            </ux-iws-calculator>
        </div>`;

const TemplateWithMatrix = () => html`<ux-form-group
        class="ux-u-margin-bottom-20"
        label="Select a machine"
    >
        <ux-radio-button
            label="machine a"
            name="machine"
            value="machine a"
            checked
            data-ux-calculator="with-matrix"
            data-ux-calculator-type="machine"
        ></ux-radio-button>
        <ux-radio-button
            label="machine b"
            name="machine"
            value="machine b"
            data-ux-calculator="with-matrix"
            data-ux-calculator-type="machine"
        ></ux-radio-button>
    </ux-form-group>
    <ux-form-group label="Select a tonnage">
        <ux-radio-button
            label="Item with tonnage 100"
            name="tonnage"
            value="100"
            checked
            data-ux-calculator="with-matrix"
            data-ux-calculator-type="tonnage"
        ></ux-radio-button>
        <ux-radio-button
            label="Item with value 200"
            name="tonnage"
            value="200"
            data-ux-calculator="with-matrix"
            data-ux-calculator-type="tonnage"
        ></ux-radio-button>
    </ux-form-group>
    <div class="ux-u-margin-top-15">
        <div class="ux-label">
            Your total price is:
        </div>
        <ux-data-ingest matrix="#matrix">
            <ux-iws-calculator
                calculator-id="with-matrix"
                initial-value="40000"
                matrix
            >
                <span slot="suffix"> €</span>
            </ux-iws-calculator>
            <script type="application/json" data-id="matrix">
                [
                    {
                        "machine": "machine a",
                        "tonnage": "100",
                        "value": 65700
                    },
                    {
                        "machine": "machine a",
                        "tonnage": "200",
                        "value": 66000
                    },
                    {
                        "machine": "machine b",
                        "tonnage": "100",
                        "value": 72000
                    },
                    {
                        "machine": "machine b",
                        "tonnage": "200",
                        "value": 74000
                    }
                ]
            </script>
        </ux-data-ingest>
    </div>`;

export const Default = Template.bind({});
Default.args = {
    calculatorId: "software",
    initialValue: 10,
};

export const WithMatrix = TemplateWithMatrix.bind({});
